import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

export type RecentItem = {
  key: string;
  defaultValue: string;
  label: string;
  icon: React.ReactNode;
  path: string;
  disabled?: boolean;
  role?: string;
  roles?: string[];
};

export type Section = {
  titleKey: string;
  titleDefault: string;
  label: string;
  items: RecentItem[];
};

export function getJumpMenuNavItems(
  recentPatientsItems: RecentItem[],
  recentConsultationsItems: RecentItem[],
  includeRecentData: boolean = false
): Section[] {
  const recentRows = includeRecentData
    ? [
        {
          titleKey: "jumpMenu.recent_patients",
          titleDefault: "Recent Patients",
          label: "Recent Patients",
          items: recentPatientsItems,
        },
        {
          titleKey: "jumpMenu.recent_consultations",
          titleDefault: "Recent Consultations",
          label: "Recent Consultations",
          items: recentConsultationsItems,
        },
      ]
    : [];

  return [
    {
      titleKey: "jumpMenu.core",
      titleDefault: "Core",
      label: "Core",
      items: [
        {
          key: "all_patients",
          defaultValue: "All patients",
          label: "All patients",
          icon: <PersonIcon />,
          path: "/patients",
        },
          {
            key: "appointments",
            defaultValue: "Appointments",
            label: "Appointments",
            icon: <BookIcon />,
            path: "/appointments",
          },
          {
            key: "reminders",
            defaultValue: "Reminders",
            label: "Reminders",
            icon: <NotificationsActiveIcon />,
            path: "/reminders",
            roles: ["admin", "doctor", "staff"],
          },
        // Invitations are admin-only (same guard as the /admin route); the
        // role filter in useGetSections hides this for everyone else.
        {
          key: "invite_people",
          defaultValue: "Invite people",
          label: "Invite people",
          icon: <PersonAddAlt1Icon />,
          path: "/admin/users/invite",
          role: "admin",
        },
        // {
        //   key: "all_consultations",
        //   defaultValue: "All consultations",
        //   label: "All consultations",
        //   icon: <BookIcon />,
        //   path: "/consultations",
        // },
      ],
    },

    ...recentRows,
    {
      titleKey: "jumpMenu.settings",
      titleDefault: "Settings",
      label: "Settings",
      items: [
        {
          key: "my_profile",
          defaultValue: "My Profile",
          label: "My Profile",
          icon: <AccountCircleIcon />,
          path: "/profile",
        },
        {
          key: "sign_out",
          defaultValue: "Logout",
          label: "Logout",
          icon: <LogoutIcon />,
          path: "/auth/logout",
        },
      ],
    },
  ];
}
